type Types =
  | "title"
  | "subtitle"
  | "privacyPolicy"
  | "cookiePolicy"
  | "terms"
  | "assessmentCountLimitTitle"
  | "assessmentCountLimitDescription"
  | "assessmentCountLimitSubDescription"
  | "expiredDateTitle"
  | "expiredDateDescription"
  | "valuationResultDescription1"
  | "valuationResultDescription2"
  | "valuationResultContact"
  | "serviceAnnotation1"
  | "serviceAnnotation2"
  | "serviceAnnotation3"
  | "contactLinkText"
  | "monthlyAssessmentCountLimitTitle"
  | "monthlyAssessmentCountLimitSubDescription1"
  | "monthlyAssessmentCountLimitSubDescription2"
  | "monthlyAssessmentCountLimitSubDescription3";

type Messages = { [T in Types]: string };

const messages: Messages = {
  title: "自動査定ツール",
  subtitle: "AIによる物件査定価格をお知らせします！",
  privacyPolicy: "プライバシーポリシー",
  cookiePolicy: "Cookieポリシー",
  terms: "利用規約",
  assessmentCountLimitTitle: "既に査定回数上限に達しています",
  assessmentCountLimitDescription:
    "本サービスの査定回数には上限値があります。\n既に上限数までご利用いただいておりますので、本サービスはご利用いただけません。",
  assessmentCountLimitSubDescription: "＊査定が必要な場合は、弊社営業担当者宛に訪問査定をご依頼ください。",
  expiredDateTitle: "AI査定が行えるページの有効期限が切れています。",
  expiredDateDescription:
    "AI査定が行えるページには有効期限が存在します。\n査定が必要な場合は弊社営業担当者宛に訪問査定をご依頼ください。",
  valuationResultDescription1: "※ 上記査定価格は、査定実施日時点の査定価格となります。",
  valuationResultDescription2:
    "※ 上記査定価格はあくまでも参考金額となり、訪問査定による実査定価格や売却時の売却価格を保証するものではございません。",
  valuationResultContact: "不動産のご売却・ご購入のご相談は下記までお気軽にお問合せください。",
  serviceAnnotation1: "※本ウェブサイトでご利用いただけるAI査定は、有効期限や回数制限があります",
  serviceAnnotation2: "※AI査定いただいた物件について、担当よりご連絡させていただく場合があります",
  serviceAnnotation3: "※査定結果はご入力いただいたメールアドレスにご連絡いたします",
  contactLinkText: "お問い合わせ",
  monthlyAssessmentCountLimitTitle: "査定受付の上限に達しています",
  monthlyAssessmentCountLimitSubDescription1: "お問い合わせくださりありがとうございます。",
  monthlyAssessmentCountLimitSubDescription2: "AI 査定サービスですが、盛況につき今月の査定回数の上限に達しております。",
  monthlyAssessmentCountLimitSubDescription3: "下記よりお問い合わせいただければ幸いです。",
};

export default messages;
